import { Entity } from '.'

/**
 * An entity builder helper
 */
export class EntityBuilder {

    /**
     * Will dynamically build an instance of a entity class given
     *
     * @param buildClass
     * @param data
     * @param convertToCamel
     * @returns {any}
     */
    public static buildOne<T extends Entity>(buildClass: any, data: any, convertToCamel = false): T {
        const instance: any = new buildClass() as T
        instance.fromJson(data, convertToCamel)

        return instance
    }

    /**
     * Will dynamically build many instances of an entity class given
     *
     * @param buildClass
     * @param data
     * @param convertToCamel
     * @returns {Array<T>}
     */
    public static buildMany<T extends Entity>(buildClass: any, data: Array<{}>, convertToCamel = false): T[] {
        return data.map((element) => this.buildOne<T>(buildClass, element, convertToCamel))
    }
}
